"use strict";

exports.__esModule = true;
exports.getChainType = getChainType;
var _types = require("../types");
function getChainType(type) {
  const tests = new Map([[/dev/i, _types.ChainType.MANDALA], [/mandala/i, _types.ChainType.MANDALA], [/acala/i, _types.ChainType.ACALA], [/karura/i, _types.ChainType.KARURA]]);
  for (const [test, chainTyep] of tests.entries()) {
    if (test.test(type)) return chainTyep;
  }
  return _types.ChainType.MANDALA;
}